import React from 'react';

const Duration = () => {
  return (
    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 16 16"
      style={{ enableBackground: 'new 0 0 16 16' }} xmlSpace="preserve">
      <circle className="st0" cx="8" cy="8" r="6.7" />
      <polyline className="st0" points="8,4 8,8 10.7,9.3 " />
    </svg>
  );
};

export default Duration;